module.exports = __webpack_public_path__ + "img/main_banner.5d1f9d19.png";